function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 0.902344C13.2917 0.902344 15.2396 1.71159 16.8438 3.33008C18.4479 4.94857 19.25 6.88932 19.25 9.15234V18.3477C19.25 19.0924 18.9779 19.737 18.4336 20.2812C17.8893 20.8255 17.2448 21.0977 16.5 21.0977H11V19.25H17.4023V18.3477H13.75V11H17.4023V9.15234C17.4023 7.3763 16.7793 5.86523 15.5332 4.61914C14.2871 3.37305 12.776 2.75 11 2.75C9.22396 2.75 7.71289 3.37305 6.4668 4.61914C5.2207 5.86523 4.59766 7.3763 4.59766 9.15234V11H8.25V18.3477H5.5C4.75521 18.3477 4.11068 18.0755 3.56641 17.5312C3.02214 16.987 2.75 16.3424 2.75 15.5977V9.15234C2.75 6.88932 3.55208 4.94857 5.15625 3.33008C6.76042 1.71159 8.70833 0.902344 11 0.902344Z",
  fill: "currentColor"
});

function SvgHomeHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHelp);
export default __webpack_public_path__ + "static/media/home-help.2b324ec7.svg";
export { ForwardRef as ReactComponent };